import React, { useEffect } from "react";
import { Row, Form, Input } from "antd";

const Name = ({ state = {}, readOnly, placeholder, ...props }) => {
  const { data, form, rules, onChange, keyName = "name" } = state;

  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ [keyName]: data });
  }, [data, keyName]);

  return (
    <Form form={form} style={{ width: "100%" }}>
      <Form.Item name={keyName} rules={rules}>
        <Input
          value={data}
          size="large"
          readOnly={readOnly}
          placeholder={placeholder || "Name"}
          onChange={(e) => {
            onChange({ name: e?.target?.value });
          }}
          {...props}
        />
      </Form.Item>
    </Form>
  );
};

export default Name;
